import { render } from "./TradePromotionPage.vue?vue&type=template&id=7405b00c&scoped=true"
import script from "./TradePromotionPage.vue?vue&type=script&lang=js"
export * from "./TradePromotionPage.vue?vue&type=script&lang=js"

import "./TradePromotionPage.vue?vue&type=style&index=0&id=7405b00c&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/freelance/naks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7405b00c"]])

export default __exports__